var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { id: "container-catalog" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("b-card", [
            _c(
              "div",
              { staticClass: "accordion", attrs: { id: "accordionExample" } },
              [
                _c("div", { staticClass: "accordion-item" }, [
                  _c(
                    "div",
                    {
                      class: _vm.collapseCatalog,
                      attrs: {
                        id: "collapseOne",
                        "aria-labelledby": "headingOne",
                        "data-parent": "#accordionExample"
                      }
                    },
                    [
                      _c("div", { staticClass: "row col-12" }, [
                        _c("h3", [_vm._v("Catálogos")]),
                        _c(
                          "div",
                          {
                            staticStyle: { right: "1px", position: "absolute" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  pill: "",
                                  variant: "primary",
                                  size: "sm"
                                },
                                on: { click: _vm.addObjectCatalog }
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "plus-circle-fill" }
                                }),
                                _vm._v(" Agregar Catálogo ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "row col-12 mt-3 h-100" },
                        [
                          _c("b-table", {
                            attrs: {
                              hover: "",
                              fields: _vm.listCatalogsField,
                              items: _vm.arrayListCatalog,
                              "select-mode": "single",
                              selectable: ""
                            },
                            on: { "row-selected": _vm.onRowSelectedCatalog },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(catalogName)",
                                fn: function(row) {
                                  return [
                                    row.item.catalogId !== 0
                                      ? _c("div", [
                                          _c("label", [
                                            _vm._v(_vm._s(row.item.catalogName))
                                          ])
                                        ])
                                      : _c(
                                          "div",
                                          [
                                            _c("b-form-input", {
                                              model: {
                                                value: _vm.newCatalog,
                                                callback: function($$v) {
                                                  _vm.newCatalog = $$v
                                                },
                                                expression: "newCatalog"
                                              }
                                            }),
                                            _vm.errorCatalog
                                              ? _c(
                                                  "div",
                                                  { staticClass: "form-label" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "alert alert-danger m-3",
                                                        attrs: { role: "role" }
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon:
                                                              "exclamation-triangle-fill"
                                                          }
                                                        }),
                                                        _vm._v(
                                                          " El nombre del catálogo no debe estar en blanco. "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                  ]
                                }
                              },
                              {
                                key: "cell(catalogState)",
                                fn: function(row) {
                                  return [
                                    row.item.catalogState ===
                                    _vm.materialState.ACTIVE
                                      ? _c(
                                          "vs-chip",
                                          { attrs: { title: "Activo" } },
                                          [
                                            _c("vs-avatar", {
                                              attrs: {
                                                icon: "thumb_up",
                                                color: "#26bd6a"
                                              }
                                            }),
                                            _vm._v(" Activo ")
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    row.item.catalogState ===
                                    _vm.materialState.INACTIVE
                                      ? _c(
                                          "vs-chip",
                                          { attrs: { title: "Inactivo" } },
                                          [
                                            _c("vs-avatar", {
                                              attrs: {
                                                icon: "do_not_disturb",
                                                color: "#DB1D2A"
                                              }
                                            }),
                                            _vm._v(" Inactivo ")
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(catalogServices)",
                                fn: function(row) {
                                  return _vm._l(
                                    row.item.catalogServices,
                                    function(service) {
                                      return _c(
                                        "vs-chip",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: "Servicio",
                                              expression: "'Servicio'"
                                            }
                                          ],
                                          key: service.id,
                                          staticClass: "mt-3",
                                          attrs: { title: "Servicio" }
                                        },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              icon: "description",
                                              color: "#ff9f43"
                                            }
                                          }),
                                          _vm._v(
                                            " " + _vm._s(service.nombre) + " "
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  )
                                }
                              },
                              {
                                key: "cell()",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row justify-content-end"
                                      },
                                      [
                                        row.item.catalogName === ""
                                          ? [
                                              _c("b-icon", {
                                                staticClass: "m-2",
                                                attrs: { icon: "check" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.pushCatalog(
                                                      row.index
                                                    )
                                                  }
                                                }
                                              }),
                                              _c("b-icon", {
                                                staticClass: "m-2",
                                                attrs: { icon: "trash" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteArrayCatalog(
                                                      row.index
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          : _vm._e(),
                                        row.item.catalogName !== ""
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value:
                                                        "Desplegar acciones",
                                                      expression:
                                                        "'Desplegar acciones'"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _c(
                                                    "b-dropdown",
                                                    {
                                                      attrs: {
                                                        variant: "link",
                                                        "no-caret": "",
                                                        right: "",
                                                        "data-cy":
                                                          "massive-actions"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key:
                                                              "button-content",
                                                            fn: function() {
                                                              return [
                                                                _c(
                                                                  "feather-icon",
                                                                  {
                                                                    staticClass:
                                                                      "align-middle text-body",
                                                                    attrs: {
                                                                      "data-cy":
                                                                        "gear-button",
                                                                      width:
                                                                        "24px",
                                                                      height:
                                                                        "24px",
                                                                      icon:
                                                                        "SettingsIcon"
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            },
                                                            proxy: true
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _c(
                                                        "b-dropdown-item",
                                                        {
                                                          attrs: {
                                                            "data-cy":
                                                              "edit-name"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.showModalChangeNameCatalog(
                                                                row.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("vs-icon", {
                                                            attrs: {
                                                              icon: "edit"
                                                            }
                                                          }),
                                                          _vm._v(
                                                            " Editar nombre "
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        [
                                                          row.item
                                                            .catalogState ===
                                                          _vm.materialState
                                                            .ACTIVE
                                                            ? _c(
                                                                "b-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    "data-cy":
                                                                      "deactivate"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.changeStateCatalog(
                                                                        row.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "vs-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon:
                                                                          "clear"
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(
                                                                    " Desactivar "
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "b-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    "data-cy":
                                                                      "activate"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.changeStateCatalog(
                                                                        row.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "vs-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon:
                                                                          "check"
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(
                                                                    " Activar "
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "accordion-item" }, [
                  _c(
                    "div",
                    {
                      class: _vm.collapseCategory,
                      attrs: {
                        id: "collapseTwo",
                        "aria-labelledby": "headingOne",
                        "data-bs-parent": "#accordionExample"
                      }
                    },
                    [
                      _c("div", { staticClass: "row col-md-12" }, [
                        _c("h3", [_vm._v("Categorías")]),
                        _c(
                          "div",
                          {
                            staticStyle: { right: "1px", position: "absolute" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  pill: "",
                                  variant: "primary",
                                  size: "sm"
                                },
                                on: { click: _vm.addObjectCategory }
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "plus-circle-fill" }
                                }),
                                _vm._v(" Agregar Categoría ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm.selectedLinkCatalog.catalogName
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "row col-12 mt-3 justify-content-start",
                              on: {
                                click: function($event) {
                                  return _vm.collapseDiv("catalog")
                                }
                              }
                            },
                            [
                              _c(
                                "vs-chip",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { title: "Volver a Catálogo" }
                                },
                                [
                                  _c("vs-avatar", {
                                    attrs: {
                                      icon: "arrow_back",
                                      color: "#26bd6a"
                                    }
                                  }),
                                  _vm._v(" Volver a Catálogo ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "row col-md-12 mt-3" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-border-shadow",
                              on: {
                                click: function($event) {
                                  return _vm.collapseDiv("catalog")
                                }
                              }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "h-100 m-3 text-rotate-vertical",
                                  attrs: { role: "button" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "Catálogo : " +
                                          _vm.selectedLinkCatalog.catalogName
                                      ) +
                                      " "
                                  ),
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "caret-left-fill",
                                      width: "20",
                                      height: "20"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _c("b-table", {
                            staticClass: "col-md-11 h-100 ml-3",
                            attrs: {
                              hover: "",
                              fields: _vm.listCategorysField,
                              items: _vm.catalogFiltered(_vm.category),
                              "select-mode": "single",
                              selectable: ""
                            },
                            on: { "row-selected": _vm.onRowSelectedCategory },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(descripcion)",
                                fn: function(row) {
                                  return [
                                    row.item.opcionId !== 0
                                      ? _c("div", [
                                          _c("label", [
                                            _vm._v(_vm._s(row.item.descripcion))
                                          ])
                                        ])
                                      : _c("div", [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.newCategory,
                                                  expression: "newCategory"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "select",
                                                name: "Categoría"
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.newCategory = $event
                                                    .target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                }
                                              }
                                            },
                                            [
                                              _c("option", {
                                                attrs: { disabled: "" },
                                                domProps: {
                                                  value: [
                                                    {
                                                      opcionId: 0,
                                                      descripcion: ""
                                                    }
                                                  ]
                                                }
                                              }),
                                              _vm._l(
                                                _vm.listCategorys,
                                                function(option) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: option.categoryId,
                                                      domProps: {
                                                        value: [
                                                          {
                                                            opcionId:
                                                              option.categoryId,
                                                            descripcion:
                                                              option.categoryName
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            option.categoryName
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm.errorCategory
                                            ? _c(
                                                "div",
                                                { staticClass: "form-label" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "alert alert-danger m-3",
                                                      attrs: { role: "role" }
                                                    },
                                                    [
                                                      _c("b-icon", {
                                                        attrs: {
                                                          icon:
                                                            "exclamation-triangle-fill"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        " La categoría no debe estar en blanco. "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                  ]
                                }
                              },
                              {
                                key: "cell()",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row justify-content-end"
                                      },
                                      [
                                        row.item.opcionId === 0
                                          ? _c("b-icon", {
                                              staticClass: "m-2",
                                              attrs: {
                                                icon: "check",
                                                "data-cy": "push-category-array"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.pushCategoryCatalog(
                                                    row.index
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        _c("b-icon", {
                                          staticClass: "m-2",
                                          attrs: {
                                            icon: "trash",
                                            "data-cy": "delete-category-array"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteArrayCategory(
                                                row.index
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "accordion-item" },
                  [
                    _c(
                      "div",
                      {
                        class: _vm.collapseMaterial,
                        attrs: {
                          id: "collapseThree",
                          "aria-labelledby": "headingOne",
                          "data-bs-parent": "#accordionExample"
                        }
                      },
                      [
                        _c("div", { staticClass: "row col-12" }, [
                          _c("h3", [_vm._v("Materiales")]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                right: "1px",
                                position: "absolute"
                              }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    pill: "",
                                    variant: "primary",
                                    size: "sm"
                                  },
                                  on: { click: _vm.addObjectMaterial }
                                },
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "plus-circle-fill" }
                                  }),
                                  _vm._v(" Agregar Material ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "row col-12 mt-3 justify-content-start",
                            on: {
                              click: function($event) {
                                return _vm.collapseDiv("category")
                              }
                            }
                          },
                          [
                            _c(
                              "vs-chip",
                              {
                                staticStyle: { cursor: "pointer" },
                                attrs: { title: "Volver a Categoría" }
                              },
                              [
                                _c("vs-avatar", {
                                  attrs: {
                                    icon: "arrow_back",
                                    color: "#26bd6a"
                                  }
                                }),
                                _vm._v(" Volver a Categoría ")
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("div", { staticClass: "row col-12 mt-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "text-border-shadow",
                              on: {
                                click: function($event) {
                                  return _vm.collapseDiv("catalog")
                                }
                              }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "h-100 m-3 text-rotate-vertical",
                                  attrs: { role: "button" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "Catálogo : " +
                                          _vm.selectedLinkCatalog.catalogName
                                      ) +
                                      " "
                                  ),
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "caret-left-fill",
                                      width: "20",
                                      height: "20"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "text-border-shadow",
                              on: {
                                click: function($event) {
                                  return _vm.collapseDiv("category")
                                }
                              }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "h-100 m-3 text-rotate-vertical",
                                  attrs: { role: "button" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "Categoría: " + _vm.selectedLinkCategory
                                      ) +
                                      " "
                                  ),
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "caret-left-fill",
                                      width: "20",
                                      height: "20"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-11" },
                            [
                              _c("b-table", {
                                attrs: {
                                  hover: "",
                                  fields: _vm.listMaterialsField,
                                  items: _vm.catalogFiltered(_vm.material)
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(nameMaterial)",
                                    fn: function(row) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(row.item.nameMaterial) +
                                            " "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(brandMaterial)",
                                    fn: function(row) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.item.brandMaterial.descripcion
                                            ) +
                                            " "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(priceMaterial)",
                                    fn: function(row) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("toCurrency")(
                                                parseInt(row.item.priceMaterial)
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(quantityMaterial)",
                                    fn: function(row) {
                                      return [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value:
                                                "required|numeric|min_value:1|max_value:" +
                                                _vm.quantityMax,
                                              expression:
                                                "`required|numeric|min_value:1|max_value:${quantityMax}`"
                                            }
                                          ],
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "number",
                                            "data-vv-as": "Cantidad",
                                            name: "cantidad"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.validQuantity(row)
                                            }
                                          },
                                          model: {
                                            value: row.item.quantityMaterial,
                                            callback: function($$v) {
                                              _vm.$set(
                                                row.item,
                                                "quantityMaterial",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "row.item.quantityMaterial"
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell()",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row justify-content-end"
                                          },
                                          [
                                            _c("b-icon", {
                                              staticClass: "m-2",
                                              attrs: { icon: "trash" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteArrayMaterial(
                                                    row.index
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm.newRegister
                      ? _c(
                          "div",
                          {
                            staticClass: "row col-12 mt-3 justify-content-end"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "ml-2",
                                attrs: { variant: "primary" },
                                on: { click: _vm.cancelCatalog }
                              },
                              [_vm._v(" Cancelar Catálogo ")]
                            ),
                            _vm.catalogState === "new"
                              ? [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "ml-2",
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.saveNewCatalog }
                                    },
                                    [_vm._v(" Guardar Catálogo ")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.catalogState === "edit"
                              ? [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "ml-2",
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.saveEditCatalog }
                                    },
                                    [_vm._v(" Editar Catálogo ")]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    _c("PopUpAddFromUnity", {
                      attrs: {
                        whoCall: "catalog",
                        materialObject: _vm.arrayMaterial
                      },
                      on: { reload: _vm.pushMaterialCatalog }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "b-modal",
            {
              ref: "editCatalogName",
              attrs: {
                id: "edit-catalog-name",
                title: "Editar Nombre",
                "hide-footer": "",
                "no-close-on-backdrop": ""
              }
            },
            [
              _c("div", { staticClass: "row mb-5" }, [
                _c("div", { staticClass: "col-md-12 mt-3" }, [
                  _c("label", [_vm._v("Nombre")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedLinkCatalog.catalogName,
                        expression: "selectedLinkCatalog.catalogName"
                      }
                    ],
                    staticClass: "form-control",
                    domProps: { value: _vm.selectedLinkCatalog.catalogName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.selectedLinkCatalog,
                          "catalogName",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "col-md-12 mt-3" }, [
                  _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.changeNameCatalog()
                            }
                          }
                        },
                        [
                          _c("b-icon", { attrs: { icon: "folder" } }),
                          _vm._v(" Guardar ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }